import { FC, ReactNode, useState } from 'react'
import { Translation } from '@/helpers'
import { CategoryState } from '@/states'
import { TableItems } from '@/ui/components'
import { PageTitle } from '@/ui/views'
import { useCategories } from '@/hooks'

const Categories: FC = (): ReactNode => {
    useCategories()

    const { Categories, Loading } = CategoryState()
    const [deleting, setDeleting] = useState(false)

    return (
        <div className='h-full'>
            <section className='bg-[#262626] border border-[#424242] p-2 px-4 pt-0.5 pb-4 rounded-md w-full'>
                <PageTitle title={Translation('categories')} />

                <div className='hidden lg:block'>
                    <TableItems
                        target='category'
                        list={Categories}
                        loading={Loading}
                        headers={['Name', 'Last Updated', 'Actions']}
                        deleting={deleting}
                        setDeleting={setDeleting}
                    />
                </div>

                <div className='block lg:hidden'>
                    <TableItems
                        target='category'
                        list={Categories}
                        loading={Loading}
                        headers={['Name']}
                        deleting={deleting}
                        setDeleting={setDeleting}
                    />
                </div>
            </section>
        </div>
    )
}

export default Categories
